import React from 'react';
import Axios from 'axios';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import moment from 'moment';

class QvneaBooksRegisterModal extends React.Component {

	newSubscription = {type: '', name: '', type2: ''};

  constructor(props) {
		super(props);
		this.state = {
			modalData: props.modalData,
			playerCost: props.modalData.season.playerCost,
			playerPayout: 0,
			playerCostChanged: false,
			selectInscOrBourses: "Inscriptions"
		};
		this.dispPlayers = this.dispPlayers.bind(this);
		this.handlePlayerCostChange = this.handlePlayerCostChange.bind(this);
		this.handleSelectInscOrBourses = this.handleSelectInscOrBourses.bind(this);
	}

	componentDidMount() {
		// console.log('QvneaBooksRegisterModal: componentDidMount');
		this.initModalState(this.props);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		// console.log('QvneaBooksRegisterModal: UNSAFE_componentWillReceiveProps');
		// console.log(nextProps)
		this.initModalState(nextProps);
	}

	componentDidUpdate() {
		var _this = this;
		var modalData = this.state.modalData;

		//console.log('componentDidUpdate')
		//console.log(this.state.selectInscOrBourses)

		if (this.newSubscription.type !== '') {
			setTimeout(function() {
				if (_this.newSubscription.type === 'player-league') {
					if(_this.newSubscription.operType === "inscription") {
						modalData.statusMessage = "Joueur inscrit: " + _this.newSubscription.name + " (ligue)";
					} else {
						modalData.statusMessage = "Bourse inscrite: " + _this.newSubscription.name;
					}
					_this.setState({modalData: modalData});
				}
				if (_this.newSubscription.type === 'team-league') {
					if(_this.newSubscription.operType === "inscription") {
						modalData.statusMessage = "Joueurs de l'équipe inscrits: " + _this.newSubscription.name + " (ligue)";
					} else {
						modalData.statusMessage = "Bourses inscrites aux joueurs: " + _this.newSubscription.name;
					}
					_this.setState({modalData: modalData});
				}
				if (_this.newSubscription.type === 'player-membershipcard') {
					modalData.statusMessage = "Joueur inscrit: " + _this.newSubscription.name + " (carte de membre)";
					_this.setState({modalData: modalData});
				}
				if (_this.newSubscription.type === 'team-membershipcard') {
					modalData.statusMessage = "Joueurs de l'équipe inscrits: " + _this.newSubscription.name + " (carte de membre)";
					_this.setState({modalData: modalData});
				}
				_this.newSubscription = {type: '', name: ''};
			}, 0);
		}		
	}

	initModalState(props) {
		var initPlayerCost = props.modalData.season.playerCost;
		if (this.state.playerCostChanged) {
			initPlayerCost = this.state.playerCost;
		}
		this.setState({
			modalData: props.modalData,
			playerCost: initPlayerCost,
		});
	}

	render() {
		//console.log('QvneaBooksRegisterModal: render');
		//console.log(this.props);
		//console.log(this.state);

		return (
    	<Modal 
  			isOpen={this.props.showModal} 
    		//toggle={this.props.handleQvneaBooksModalCancel}		// when clicking outside the modal
				size="lg"
    		className={this.props.className}>

        <form className="form-horizontal" /*onSubmit={this.handleSave}*/>
    		<ModalHeader>
    			{/* toggle={this.props.handleQvneaBooksModalCancel}> displays a small X in header */}
    			QVNEA Books
    		</ModalHeader>

    		<ModalBody>
					{this.dispForm()}
    		</ModalBody>

    		<ModalFooter>
      		<button type="button" className="btn btn-secondary btn-sm stdCommandButton2" 
      			onClick={this.props.handleQvneaBooksModalCancel}> Fermer
      		</button>
    		</ModalFooter>
    		</form>
    	</Modal>
    )
	}

	dispForm() {
		var amountText = "Inscription par joueur";
		var btnEquipeText = "Inscription Équipe (Ligue)";
		var cmText = "Carte de Membre";
		if (this.state.selectInscOrBourses === "Bourses") {
			amountText = "Bourse par joueur";
			btnEquipeText = "Bourse Équipe";
			cmText = "";
		}

		return (
			<div>
        <div className="row row-margin-bottom-10">
        <div className="col-12">
					<strong> Saison </strong> <br/>
					<span> {this.props.modalData.season.name} </span><br/>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-md-4 col-6">
					<label className="switch switch-3d switch-sm switch-success form-control-label">
					<input type="checkbox" className="switch-input form-check-input" 
						checked={(this.state.selectInscOrBourses === "Bourses") || false} onChange={this.handleSelectInscOrBourses}/>								
						<span className="switch-label"></span>
					<span className="switch-handle"></span>
					</label>
					&nbsp;&nbsp;{this.state.selectInscOrBourses}
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-md-4 col-6">
		  		<label htmlFor="playerCost" className="small labelSmallMarginBottom">{amountText}</label>
		  		<input className="form-control form-control-sm" type="text" id="playerCost" 
		  			value={this.state.playerCost} onChange={this.handlePlayerCostChange}/>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-12">
					<strong>{this.state.selectInscOrBourses} de l'équipe</strong><br/>
					<span> {this.props.modalData.team.name} </span><br/>
					<span>Nombre de joueurs: {this.props.modalData.team.players.length} </span>
				</div>
				</div>

        <div className="row row-margin-bottom-10">
        <div className="col-12">
					<button type="button" className="btn btn-sm btn-qvnea no-margin-bottom btn-margin-right-20" 
						onClick={this.handleRegisterTeam.bind(this, this.props.modalData.team.name, 'league')}>
						{btnEquipeText}
					</button>

					{(this.state.selectInscOrBourses === "Inscriptions") ?
						<button type="button" className="btn btn-sm btn-qvnea no-margin-bottom" 
							onClick={this.handleRegisterTeam.bind(this, this.props.modalData.team.name, 'membershipcard')}>
							Inscrire équipe (Carte de Membre)
						</button>
						: null}

				</div>
				</div>
				<br/>

        <div className="row">
        <div className="col-12">
					<table className="table">
					<thead>
						<tr>
							<th>Joueurs</th>
							<th>{this.state.selectInscOrBourses}</th>
							<th>{cmText}</th>
							<th colSpan="2"></th>
						</tr>
					</thead>
					<tbody>
						{this.props.modalData.team.players.map(this.dispPlayers)}
					</tbody>
					</table>
				</div>
				</div>

        <div className="row">
        <div className="col-12">
        	<p><i>Statut: {this.state.modalData.statusMessage}</i></p>
				</div>
				</div>
			</div>
		)
	}

	dispPlayers(p, pIdx) {
  	var summaryText = '';
  	var cmText = '';

  	var buttonText = "INSCRIPTION";
  	if ((p.qvneaBooks !== undefined) && (Object.keys(p.qvneaBooks).length !== 0)) {
			summaryText = p.qvneaBooks.inscriptionsCount + ' (' + 
				-(p.qvneaBooks.inscriptionsTotal).toFixed(2) + ' $)';
			cmText = (-p.qvneaBooks.mccInscriptions).toFixed(2) + ' $'; 
  	}

  	if (this.state.selectInscOrBourses === "Bourses") {
  		buttonText = "BOURSE";
  		cmText = "";
	  	if ((p.qvneaBooks !== undefined) && (Object.keys(p.qvneaBooks).length !== 0)) {
				summaryText = p.qvneaBooks.payoutsCount + ' (' + 
					(p.qvneaBooks.payoutsTotal).toFixed(2) + ' $)';
	  	}
  	}

		return (
			<tr key={'dpl' + pIdx}>
				<td>{p.name}</td>
				<td>{summaryText}</td>
				<td>{cmText}</td>
				<td> 
					<button type="button" className="btn btn-sm2 btn-qvnea btn-extra-padding-2 no-margin-bottom" 
						onClick={this.handleRegisterPlayer.bind(this, p.playerId, p.name, 'league')}>
						{buttonText}
					</button>
				</td>

				<td> 
					{(this.state.selectInscOrBourses === "Inscriptions") ?
						<button type="button" className="btn btn-sm2 btn-qvnea btn-extra-padding no-margin-bottom" 
							onClick={this.handleRegisterPlayer.bind(this, p.playerId, p.name, 'membershipcard')}>
							CARTE DE MEMBRE
						</button>
						: null}
				</td>

			</tr>
		)
	}

	handleSelectInscOrBourses(e) {
		var playerCost = '0';
		if (!e.target.checked) {
			playerCost = this.props.modalData.season.playerCost;
		}

		this.setState({
			playerCost: playerCost,
			selectInscOrBourses: (e.target.checked ? "Bourses" : "Inscriptions")
		});
	}

	handlePlayerCostChange(e) {
		this.setState({
			playerCost: e.target.value,
			playerCostChanged: true
		});
	}

	handleRegisterTeam(teamName, option) {
		// date: moment(new Date())
		// playerId
		// type
		// leagueId
		// seasonId
		// debit
		// credit
		// notes: (gestion des équipes)

		var _this = this;
		var operType = '';

		if (this.newSubscription.type !== '') {
			return;
		}
		this.newSubscription = {type: 'updating', name: '', operType: ''};

		// Inscriptions / Bourses
		if (this.state.selectInscOrBourses === "Inscriptions") {
			operType = "inscription";
		} else {
			operType = "bourse";
		}

		var playerIds = [];
		this.props.modalData.team.players.forEach(tp => {
			playerIds.push(tp.playerId)
		});

		var qvneaBooksObj = {
			date: moment(new Date()),
			playerIds: playerIds,
			seasonId: this.props.modalData.season._id,
			playerCost: parseFloat(this.state.playerCost),
			type: operType,
			option: option,
			user: this.props.user
		};

		Axios.post('/api/qvneaBooks/registerTeam', {
			qvneaBooksObj: qvneaBooksObj
		})
		.then(function(response) {
			if (response.data.msg === "playerCostZero") {
				alert("Le montant n'est pas spécifié.")
				_this.newSubscription.type = '';
			} else if (response.data.msg === "noMembershipSeason") {
				alert("Aucune carte de membre spécifiée dans les paramètres de saison.")
				_this.newSubscription.type = '';
			} else {
				_this.props.handleQvneaBooksReloadData();
				_this.newSubscription = {type: 'team-' + option, name: teamName, operType: operType};
			}
		})
		.catch(function(error) {
			console.log('ERROR');
			console.log(error);
		});
	}

	handleRegisterPlayer(playerId, playerName, option) {
		var _this = this;
		var operType = '';

		if (this.newSubscription.type !== '') {
			return;
		}
		this.newSubscription = {type: 'updating', name: ''};

		// Inscriptions / Bourses
		if (this.state.selectInscOrBourses === "Inscriptions") {
			operType = "inscription";
		} else {
			operType = "bourse";
		}

		var qvneaBooksObj = {
			date: moment(new Date()),
			playerId: playerId,
			seasonId: this.props.modalData.season._id,
			playerCost: parseFloat(this.state.playerCost),
			type: operType,
			option: option,
			user: this.props.user
		};

		Axios.post('/api/qvneaBooks/registerPlayer', {
			qvneaBooksObj: qvneaBooksObj
		})
		.then(function(response) {
			if (response.data.msg === "playerCostZero") {
				alert("Le montant n'est pas spécifié.")
				_this.newSubscription.type = '';
			} else if (response.data.msg === "noMembershipSeason") {
				alert("Aucune carte de membre spécifiée dans les paramètres de saison.")
				_this.newSubscription.type = '';
			} else {
				_this.props.handleQvneaBooksReloadData();
				_this.newSubscription = {type: 'player-' + option, name: playerName, operType: operType};
			}
		})
		.catch(function(error) {
			console.log('ERROR');
			console.log(error);
		});
		
	}

}

export default QvneaBooksRegisterModal;